<!--
  BudgetFormModal: alta y edición de presupuestos, con el modal de condiciones de pago.

  ENTRADA
    Props: no tiene.
    Métodos públicos (por ref):
      add()                 Abre el alta vacía.
      edit(item)            Abre la edición. item: presupuesto de la API; el detalle se busca
                            con mostrarPresupuesto(item.id).
      close()               Cierra el modal sin confirmar.
      nextTab()             Avanza el wizard, si está abierto.
      openCustomerSearch()  Abre el buscador de clientes, si el modal está abierto.

  SALIDA
    Eventos:
      @saved(response)            Se guardó. response: respuesta de la API. La vista recarga lo que corresponda.
      @price-list-change(lista)   Cambió la lista de precios del formulario. crudBudget toma de acá la moneda
                                  con la que muestra importes en listado y detalle.
    Efectos:
      POST budgets (alta) y POST budgets/{id} (edición). Mientras se edita consulta numeración y totales.
      No genera movimientos de stock, caja ni contabilidad.

  USOS
    Vista: <BudgetFormModal ref="budgetForm" @saved="filterBudgets(true)" />
    Alta:     this.$refs.budgetForm.add()
    Edición:  this.$refs.budgetForm.edit(item)
    Hoy se invoca desde budgets/staff/crudBudget.vue: botón, dropdown y drawer, ?new=1 de la paleta de comandos y Ctrl+Shift+P.

  DEPENDENCIAS Y PERMISOS
    Parámetros: P51 (ítems duplicados), P65 (precios sin IVA), P67 (contacto obligatorio).
    Módulos: Servicios muestra "Recurrente" y "Título".
    Componentes: FindObject, cpbtDetail/detail, inc/methodPayment.
    No controla permisos: quien lo invoca decide si el usuario puede abrirlo.
    Los atajos de teclado los registra la vista y llama a los métodos públicos.
-->
<template>
  <div>
    <!-- CRUD MAIN -->
    <b-modal v-model="modal.form.active"
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            size="xl"
            dialog-class="budgets-form-modal-dialog"
            :key="modal.form._id"
            :id="modal.form._id">
      <div slot="modal-header" minimize class="app-modal-header">
        <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
        <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
      </div>

      <form-wizard  title=""
                    subtitle=""
                    nextButtonText="Siguiente"
                    backButtonText="Atrás"
                    finishButtonText="Guardar"
                    color="#2f353a"
                    shape="tab"
                    @on-complete="save"
                    class="crud-budgets-wizard"
                    ref="wizard">

        <tab-content title="General" icon="fa fa-edit" :before-change="budgetValidDetailGeneral">
          <b-row>
            <b-col md="4">
              <b-form-group label="Contacto" description="Nombre de la persona que solicitó el presupuesto">
                <b-form-input type="text"
                              size="sm"
                              v-model="crud.form.contact"
                              required
                              placeholder="Ingresar un nombre de contacto"
                              ref="input_contact">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Teléfono" description="Ej: 5493416908870 (13 dígitos)">
                <b-form-input type="text"
                              size="sm"
                              v-model="crud.form.contact_phone"
                              placeholder="Ingresar teléfono"
                              ref="input_contact_phone">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Empresa" description="Empresa del contacto">
                <b-form-input type="text"
                              size="sm"
                              v-model="crud.form.contact_company"
                              placeholder="Ingresar empresa"
                              ref="input_contact_company">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="2" v-if="moduleServiceActive">
              <b-form-checkbox
                v-model="crud.form.recurrent"
                switch
                size="sm"
                class="pull-right mt-4">
                <b>¿Es Recurrente?</b> <i>(Mensual)</i>
              </b-form-checkbox>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <FindObject render="search"
                          type="customers"
                          @select-object="loadCustomers($event)"
                          :valueID="crud.form.customers_id"
                          :where="conditionCustomersActive"
                          :disabled="crud.form.id>0"
                          ref="searchCustomer"
                          title="Buscador (F2)" />
            </b-col>
            <b-col md="4">
              <b-form-group label="Fecha">
                <b-form-datepicker size="sm" v-model="crud.form.date" placeholder="Fecha" local="es"></b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Fecha Vencimiento">
                <b-form-datepicker size="sm" v-model="crud.form.date_expiration" placeholder="Fecha Vencimiento" local="es"></b-form-datepicker>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <FindObject render="search"
                          type="erpPointsSales"
                          auto-select-single
                          display="full_identification"
                          @select-object="loadPointsSales($event)"
                          :valueID="crud.form.points_sales_id"
                          :key="crud.form.points_sales_id"
                          :disabled="crud.form.id>0"
                          :where="conditionPointsSalesActive" />
            </b-col>
            <b-col md="4">
              <FindObject render="search"
                          type="erpMethodsPayment"
                          auto-select-single
                          @select-object="loadMethodsPayment($event)"
                          :valueID="crud.form.methods_payment_id"
                          :key="crud.form.methods_payment_id" />
            </b-col>
            <b-col md="4">
              <FindObject render="search"
                          type="priceList"
                          @select-object="loadPriceList($event)"
                          :valueID="crud.form.price_list_id"
                          :key="crud.form.price_list_id"
                          :where="conditionPriceListActive"
                          :disabled="crud.form.id>0" />
            </b-col>
          </b-row>
        </tab-content>

        <tab-content title="Detalle" icon="fa fa-list" :before-change="budgetValidDetailItems">
          <b-row>
            <b-col lg="12" md="12" sm="12">
                <Detail :customer_id="crud.form.customers_id"
                        :price_list_id="crud.form.price_list_id"
                        :disable-customer-price-list-fallback="crud.form.disable_customer_price_list_fallback"
                        @load-detail-products="setDetailItems($event, 'products')"
                        @load-detail-products-compound="setDetailItems($event, 'productsCompound')"
                        @load-detail-services="setDetailItems($event, 'services')"
                        @load-detail-concepts="setDetailItems($event, 'concepts')"
                        :detailProducts="crud.form.detailProducts"
                        :detailProductsCompound="crud.form.detailProductsCompound"
                        :detailServices="crud.form.detailServices"
                        :detailConcepts="crud.form.detailConcepts"
                        :hideConcepts="false"
                        :key="'detailBudget_'+itemDetailForceUpdate"
                        :forceUpdate="itemDetailForceUpdate"
                        :validItemDuplicatedProduct="!parameters.multipleItems"
                        :validItemDuplicatedConcept="!parameters.multipleItems"
                        :not-iva="!!crud.form.not_iva"
                        :methodPayment="crud.form.methods_payment" />

                <b-row class="mt-0 pt-1 pl-3 pr-3" align-v="end">
                  <b-col md="6" :offset-md="6" class="mb-0" v-if="showCheckNotIva">
                    <b-form-checkbox
                      v-model="crud.form.not_iva"
                      switch
                      size="sm"
                      class="pull-right">
                      <b>Precios sin IVA</b>
                    </b-form-checkbox>
                  </b-col>
                </b-row>

                <b-row class="pl-3 pr-3 pb-2 mt-2">
                  <b-col md="2" class="mb-2 mb-md-0">
                    <div class="crud-budgets-stat">
                      <span class="crud-budgets-stat__label">Items</span>
                      <span class="crud-budgets-stat__value">{{this.getCantItemBudget}}</span>
                    </div>
                  </b-col>
                  <b-col md="6" class="mb-2 mb-md-0 d-flex align-items-center justify-content-center">
                    <b-button variant="outline-info" size="sm" @click="showSurchargeMethodPayment()">
                      <AppIcon name="money" class="mr-1" />Otras Condiciones de Pago
                    </b-button>
                  </b-col>
                  <b-col md="4" v-if="getCurrencyBudget">
                    <div class="crud-budgets-totals">
                      <div class="crud-budgets-totals__row">
                        <span class="crud-budgets-totals__label">Subtotal</span>
                        <span class="crud-budgets-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(totals.subtotal)}}</span>
                      </div>
                      <div class="crud-budgets-totals__row">
                        <span class="crud-budgets-totals__label">Descuento</span>
                        <div class="crud-budgets-totals__discount-group">
                          <div class="crud-budgets-totals__discount">
                            <app-text-input v-model="crud.form.percentage_discount"
                                            type="number"
                                            min="0"
                                            max="100"
                                            step="1"
                                            size="sm"
                                            @change="validDiscounts()"/>
                            <span class="crud-budgets-totals__discount-suffix">%</span>
                          </div>
                          <span class="crud-budgets-totals__value" :class="{'text-danger': parseFloat(totals.discount) > 0}">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(totals.discount)}}</span>
                        </div>
                      </div>
                      <div class="crud-budgets-totals__row">
                        <span class="crud-budgets-totals__label">Subtotal</span>
                        <span class="crud-budgets-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(totals.subtotal_discount)}}</span>
                      </div>
                      <div class="crud-budgets-totals__row">
                        <span class="crud-budgets-totals__label">IVA</span>
                        <span class="crud-budgets-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(totals.iva)}}</span>
                      </div>
                      <div class="crud-budgets-totals__row crud-budgets-totals__row--total">
                        <span class="crud-budgets-totals__label">Total</span>
                        <span class="crud-budgets-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(totals.total)}}</span>
                      </div>
                      <div class="crud-budgets-totals__row crud-budgets-totals__row--total" v-if="crud.form.methods_payment && parseFloat(crud.form.methods_payment.surcharge) > 0">
                        <span class="crud-budgets-totals__label">{{this.crud.form.methods_payment.name}} ({{ this.crud.form.methods_payment.surcharge }}%)</span>
                        <span class="crud-budgets-totals__value text-primary">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(totals.total_surcharge)}}</span>
                      </div>
                    </div>
                  </b-col>
                </b-row>

            </b-col>
          </b-row>
        </tab-content>

        <tab-content title="Observaciones" icon="fa fa-flag-checkered">
          <b-row>
            <b-col md="12">
              <b-form-group label="Observaciones">
                <app-textarea
                  v-model="crud.form.observations"
                  placeholder="Ingresar las observaciones..."
                  rows="3"
                  max-rows="6"
                  lazy
                ></app-textarea>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <hr>
            </b-col>
            <b-col md="12" v-if="moduleServiceActive">
              <b-form-group label="Título" description="Este título se utiliza en la impresión del presupuesto">
                <b-form-input type="text"
                              size="sm"
                              v-model="crud.form.title"
                              required
                              placeholder="Ingresar un título">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="Observaciones Internas" description="Estas observaciones no se muestran en la impresión">
                <app-textarea
                  v-model="crud.form.observations_internal"
                  placeholder="Ingresar las observaciones internas..."
                  rows="3"
                  max-rows="6"
                  lazy
                ></app-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </tab-content>

      </form-wizard>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" class="mr-1" @click="cancel()">Cancelar</b-button>
      </div>
    </b-modal>

    <!-- METODOS DE PAGO -->
    <b-modal v-model="modal.method_payment.active"
            no-close-on-backdrop
            hide-header-close
            size="lg">

      <div slot="modal-header" class="app-modal-header">
        <span class="app-modal-header__icon"><AppIcon name="money" /></span>
        <h5 class="app-modal-header__title">{{this.modal.method_payment.title}}</h5>
      </div>

      <b-row>
        <b-col lg="12">
          <MethodPaymentSurcharge v-if="crud.form.price_list && crud.form.price_list.currency"
                                  :amount="totals.total"
                                  :currency="crud.form.price_list.currency.code"
                                  @setMethodPayment="setMethodPayment($event)"/>

          <MethodPaymentSurcharge v-else
                                  :amount="totals.total"
                                  currency="ARS"
                                  @setMethodPayment="setMethodPayment($event)"/>
        </b-col>
      </b-row>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" class="mr-1" @click="modal.method_payment.active=false">Cancelar</b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import serviceAPI from '../services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Funciones from '@/handler/funciones'
  import FindObject from '@/components/inc/find/findObject'
  import Detail from '@/components/inc/cpbtDetail/detail'
  import moment from 'moment'
  import Param from '@/config/parameters'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import MethodPaymentSurcharge from './methodPayment'

  export default {
    name: 'BudgetFormModal',
    components: {
      FindObject,
      Detail,
      FormWizard,
      TabContent,
      MethodPaymentSurcharge,
    },
    data: () => {
      return {
        parameters: {
          multipleItems: Helper.hasParametersAccess(Param.P51),
          haveNotIva: Helper.hasParametersAccess(Param.P65),
        },
        crud: {
          form: {
            id: 0,
            date: '',
            date_expiration: '',
            types_vouchers_id: 10,
            types_vouchers: null,
            letter: '',
            number: 0,
            methods_payment_id: 0,
            methods_payment: null,
            price_list_id: 0,
            price_list: null,
            disable_customer_price_list_fallback: false,
            points_sales_id: 0,
            points_sales: null,
            observations: '',
            observations_internal: '',
            contact: '',
            contact_phone: '',
            contact_company: '',
            recurrent: false,
            title: 'Presupuesto',
            staff_id: 0,
            sellers_id: 0,
            customers_id: 0,
            customers: null,
            percentage_discount: 0,
            not_iva: false,
            detailProducts: [],
            detailProductsCompound: [],
            detailServices: [],
            detailConcepts: [],
          },
        },
        totals: {
          subtotal: 0,
          discount: 0,
          iva: 0,
          total: 0,
          total_surcharge: 0,
        },
        modal: {
          form: {
            active: false,
            title: '',
          },
          method_payment: {
            active: false,
            title: ''
          },
        },
        itemDetailForceUpdate: 0,
      }
    },
    computed: {
      moduleServiceActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules
        modules.forEach(element => {
          if(element.id == Modules.SERVICIOS) {
            status = true
          }
        })
        return status
      },

      conditionCustomersActive(){
        return [{field: 'active', condition: true}];
      },
      conditionPriceListActive(){
        return [{field: 'active', condition: true}];
      },
      conditionPointsSalesActive() {
        return [{field: 'active', condition: true}];
      },

      // CANT / CURRENCY
      getCantItemBudget() {
        var cant1 = this.crud.form.detailProducts.length
        var cant2 = this.crud.form.detailProductsCompound.length
        var cant3 = this.crud.form.detailServices.length
        var cant4 = this.crud.form.detailConcepts.length

        return parseFloat(cant1 + cant2 + cant3 + cant4)
      },
      getCurrencyBudget() {
        var currency = 'ARS'
        if(this.crud.form.price_list) {
          if(this.crud.form.price_list.currency) {
            currency = this.crud.form.price_list.currency.code
          }
        }
        return currency
      },

      // PRECIOS SIN IVA
      showCheckNotIva() {
        let status = false
        let codeAfipRI = 1 // Responsable Inscripto

        const haveNotIva = this.parameters.haveNotIva

        const pointsSales = this.crud.form.points_sales ? this.crud.form.points_sales : null
        const business = pointsSales ? pointsSales.business : null

        if(haveNotIva && business) {
          if(
            (business.fiscal_conditions_id == codeAfipRI && pointsSales.nd) ||
            (business.fiscal_conditions_id != codeAfipRI)
          ) {
            status = true
          }
        }

        return status;
      },
    },
    watch: {
      'crud.form.price_list': function (value) {
        this.$emit('price-list-change', value)
      },
      'crud.form.customers_id': function (newQuestion, oldQuestion) {
        this.searchVoucher()
      },
      'crud.form.points_sales_id': function (newQuestion, oldQuestion) {
        this.searchVoucher()
      },
      'crud.form.price_list_id': function (newQuestion, oldQuestion) {
        if(newQuestion !== oldQuestion) {
          this.detailForceUpdate()
        }
      },
      'crud.form.disable_customer_price_list_fallback': function (newQuestion, oldQuestion) {
        if(newQuestion !== oldQuestion) {
          this.detailForceUpdate()
        }
      },
      'crud.form.detailProducts': function (newQuestion, oldQuestion) {
        this.searchTotalsTemporary()
      },
      'crud.form.detailProductsCompound': function (newQuestion, oldQuestion) {
        this.searchTotalsTemporary()
      },
      'crud.form.detailServices': function (newQuestion, oldQuestion) {
        this.searchTotalsTemporary()
      },
      'crud.form.detailConcepts': function (newQuestion, oldQuestion) {
        this.searchTotalsTemporary()
      },
      'crud.form.not_iva': function (newQuestion, oldQuestion) {
        this.searchTotalsTemporary()
      }
    },
    methods: {
      // API PUBLICA PARA LA VISTA
      close() {
        this.modal.form.active = false
      },
      nextTab() {
        if(this.$refs.wizard) {
          this.$refs.wizard.nextTab();
        }
      },
      openCustomerSearch() {
        if(this.modal.form.active) {
          if(this.$refs.searchCustomer) {
            this.$refs.searchCustomer.openSearch()
          }
        }
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },

      loadCustomers (object) {
        if(object){
          this.crud.form.customers = object
          this.crud.form.customers_id = object.id

          if(object.data_fiscal) {
            if(object.data_fiscal.points_sales_id) {
              if(!this.crud.form.points_sales_id) {
                this.crud.form.points_sales = object.data_fiscal.points_sales
                this.crud.form.points_sales_id = object.data_fiscal.points_sales_id
              }
            }

            if(object.data_fiscal.methods_payment_id) {
              if(!this.crud.form.methods_payment_id) {
                this.crud.form.methods_payment = object.data_fiscal.methods_payment
                this.crud.form.methods_payment_id = object.data_fiscal.methods_payment_id

                let days = parseInt(object.data_fiscal.methods_payment.term)
                this.crud.form.date_expiration = moment(this.crud.form.date).add(days,'d').format('YYYY-MM-DD')
              }
            }
          }

          if(!this.crud.form.price_list_id) {
            if(!this.crud.form.disable_customer_price_list_fallback && object.price_list) {
              if(object.price_list.list) {
                this.crud.form.price_list = object.price_list.list
                this.crud.form.price_list_id = object.price_list.list.id
                this.crud.form.disable_customer_price_list_fallback = false
              }
            }
          }
        } else {
          this.crud.form.customers = null
          this.crud.form.customers_id = 0
          this.crud.form.disable_customer_price_list_fallback = false
        }
      },
      loadPointsSales (object) {
        if(object){
          this.crud.form.points_sales = object
          this.crud.form.points_sales_id = object.id

          // Resetear not_iva y solo cargarlo si el check debe mostrarse
          this.crud.form.not_iva = false
          // Los computed properties se evalúan síncronamente, no necesitamos $nextTick
          if(this.showCheckNotIva) {
            this.crud.form.not_iva = object.not_iva
          }
        } else {
          this.crud.form.points_sales = null
          this.crud.form.points_sales_id = 0
          this.crud.form.not_iva = false
        }
      },
      loadMethodsPayment (object) {
        if(object){
          this.crud.form.methods_payment = object
          this.crud.form.methods_payment_id = object.id
        } else {
          this.crud.form.methods_payment = null
          this.crud.form.methods_payment_id = 0
        }
      },
      loadPriceList (object) {
        if(object){
          this.crud.form.price_list = object
          this.crud.form.price_list_id = object.id
          this.crud.form.disable_customer_price_list_fallback = false
        } else {
          this.crud.form.price_list = null
          this.crud.form.price_list_id = 0
          this.crud.form.disable_customer_price_list_fallback = true
        }
      },

      add() {
        this.crud.form.id = 0
        this.crud.form.date = moment().format('YYYY-MM-DD')
        this.crud.form.date_expiration = moment().add(10,'d').format('YYYY-MM-DD')
        this.crud.form.observations = ''
        this.crud.form.observations_internal = ''
        this.crud.form.contact = ''
        this.crud.form.contact_phone = ''
        this.crud.form.contact_company = ''
        this.crud.form.recurrent = false
        this.crud.form.title = 'Presupuesto'
        this.crud.form.staff_id = Helper.getStaffId()
        this.crud.form.sellers_id = 0
        this.crud.form.customers_id = 0
        this.crud.form.customers = null
        this.crud.form.points_sales_id = 0
        this.crud.form.points_sales = null
        this.crud.form.methods_payment_id = 0
        this.crud.form.methods_payment = null
        this.crud.form.price_list_id = 0
        this.crud.form.price_list = null
        this.crud.form.disable_customer_price_list_fallback = false
        this.crud.form.percentage_discount = 0
        this.crud.form.detailProducts = []
        this.crud.form.detailProductsCompound = []
        this.crud.form.detailServices = []
        this.crud.form.detailConcepts = []

        setTimeout(()=>{
          if(this.$refs.input_contact) {
            this.$refs.input_contact.focus()
          }
        }, 1000)

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Presupuesto"
        this.modal.form.active = true
      },
      edit(item) {
        let loader = this.$loading.show();

        this.crud.form.id = item.id
        this.crud.form.date = moment(item.date).format('YYYY-MM-DD')
        this.crud.form.date_expiration = moment(item.date_expiration).format('YYYY-MM-DD')
        this.crud.form.observations = item.observations
        this.crud.form.observations_internal = item.observations_internal
        this.crud.form.contact = item.contact
        this.crud.form.contact_phone = item.contact_phone
        this.crud.form.contact_company = item.contact_company
        this.crud.form.recurrent = item.recurrent
        this.crud.form.title = item.title
        this.crud.form.staff_id = item.staff_id
        this.crud.form.sellers_id = item.sellers_id
        this.crud.form.customers_id = item.customers_id
        this.crud.form.customers = item.customer
        this.crud.form.points_sales_id = item.points_sales_id
        this.crud.form.points_sales = item.point_sale
        this.crud.form.methods_payment_id = item.methods_payment_id
        this.crud.form.methods_payment = item.methods_payment
        this.crud.form.price_list_id = item.price_list_id
        this.crud.form.price_list = item.price_list
        this.crud.form.disable_customer_price_list_fallback = !item.price_list_id
        this.crud.form.percentage_discount = item.percentage_discount
        this.crud.form.types_vouchers = item.type_voucher
        this.crud.form.types_vouchers_id = item.types_vouchers_id
        this.crud.form.letter = item.letter
        this.crud.form.number = item.number

        var result = serviceAPI.mostrarPresupuesto(item.id);

        result.then((response) => {
          var data = response.data.detail

          if(data) {
            this.crud.form.detailProducts = []
            this.crud.form.detailProductsCompound = []
            this.crud.form.detailServices = []
            this.crud.form.detailConcepts = []

            data.forEach(element => {
              if(element.product) {
                this.crud.form.detailProducts.push(element)
              }
              if(element.productCompound) {
                this.crud.form.detailProductsCompound.push(element)
              }
              if(element.service) {
                this.crud.form.detailServices.push(element)
              }
              if(element.concept) {
                this.crud.form.detailConcepts.push(element)
              }
            });
          }

          setTimeout(()=>{
            if(this.$refs.input_contact) {
              this.$refs.input_contact.focus()
            }
          }, 1000)

          this.modal.form._id = Math.random().toString(36).slice(2, 8)
          this.modal.form.title = "Editar Presupuesto"
          this.modal.form.active = true
          loader.hide()

          this.searchVoucher()
        })
      },
      save() {
        if(this.crud.form.contact_phone && !Funciones.validarTelefonoWhatsapp(this.crud.form.contact_phone)) {
          this.$awn.alert("El Teléfono no posee un formato válido para Whatsapp (cod país [sin el signo] + nueve [9] + cod área [sin el 0] + nro cel [sin el 15], total 13 dígitos)");
          return false
        }

        this.confirmDialog('¿Desea continuar con la generación del presupuesto?', {
          title: 'Generar Presupuesto',
          okTitle: 'GENERAR'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            if (this.crud.form.id) {
              var result = serviceAPI.editarPresupuesto(this.crud.form);
            } else {
              var result = serviceAPI.agregarPresupuesto(this.crud.form);
            }

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.$emit('saved', response)
              this.$awn.success("Presupuesto generado con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      cancel() {
        this.confirmDialog('¿Desea cancelar el presupuesto?', {
          title: 'Cancelar el Presupuesto',
          icon: 'warning',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            this.modal.form.active = false
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      setDetailItems(event, type) {
        if(type=="products") {
          this.crud.form.detailProducts = event
        }
        if(type=="productsCompound") {
          this.crud.form.detailProductsCompound = event
        }
        if(type=="services") {
          this.crud.form.detailServices = event
        }
        if(type=="concepts") {
          this.crud.form.detailConcepts = event
        }
      },
      budgetValidDetailGeneral() {
        this.searchTotalsTemporary()

        if(!this.crud.form.customers_id) {
          this.$awn.alert("No se cargó el cliente");
          return false;
        }
        if(!this.crud.form.points_sales_id) {
          this.$awn.alert("No se cargó el punto de venta");
          return false;
        }
        if(!this.crud.form.methods_payment_id) {
          this.$awn.alert("No se cargó la condición de pago");
          return false;
        }

        if(Helper.hasParametersAccess(Param.P67)) {
          if(!this.crud.form.contact || this.crud.form.contact.trim() === '') {
            this.$awn.alert("Debe ingresar el nombre del contacto");
            return false;
          }
          if(!this.crud.form.contact_phone || this.crud.form.contact_phone.trim() === '') {
            this.$awn.alert("Debe ingresar el teléfono del contacto");
            return false;
          }
        }

        return true;
      },
      budgetValidDetailItems() {
          if( this.crud.form.detailProducts.length ||
              this.crud.form.detailProductsCompound.length ||
              this.crud.form.detailServices.length ||
              this.crud.form.detailConcepts.length) {
            return true;
          } else {
            this.$awn.alert("No se cargó ningún item");
            return false;
          }
      },

      // SELECT VOUCHER
      searchVoucher() {
        if(!this.crud.form.id) {
          if(this.crud.form.customers_id && this.crud.form.points_sales_id ) {
            var result = serviceAPI.obtenerVoucherById({
              'points_sales_id': this.crud.form.points_sales_id,
              'types_vouchers_id' : this.crud.form.types_vouchers_id,
            });
            result.then((response) => {
              this.crud.form.types_vouchers = response.data.type_voucher
              this.crud.form.letter = response.data.type_voucher.letter
              this.crud.form.number = response.data.number

              if( this.crud.form.types_vouchers ) {
                this.modal.form.title = this.crud.form.types_vouchers.name
                this.modal.form.title = this.modal.form.title + ' ' + this.crud.form.points_sales.point_sale.toString().padStart(4,'0')
                this.modal.form.title = this.modal.form.title + '-' + this.crud.form.number.toString().padStart(8,'0')
              }

            })
          }
        } else {
          if( this.crud.form.types_vouchers ) {
            this.modal.form.title = this.crud.form.types_vouchers.name
            this.modal.form.title = this.modal.form.title + ' ' + this.crud.form.points_sales.point_sale.toString().padStart(4,'0')
            this.modal.form.title = this.modal.form.title + '-' + this.crud.form.number.toString().padStart(8,'0')
          }
        }
      },
      searchTotalsTemporary() {
        if(this.crud.form.detailProducts || this.crud.form.detailProductsCompound || this.crud.form.detailsServices || this.crud.form.detailsConcepts) {
          var result = serviceAPI.obtenerVoucherTotalsTemporary({
            'header': this.crud.form,
            'detailsProducts': this.crud.form.detailProducts,
            'detailsProductsCompound': this.crud.form.detailProductsCompound,
            'detailsServices': this.crud.form.detailServices,
            'detailsConcepts': this.crud.form.detailConcepts,
            'methods_payment': this.crud.form.methods_payment,
          });
          result.then((response) => {
            var data = response.data

            this.totals.subtotal = data.amount_net
            this.totals.discount = data.amount_discount
            this.totals.subtotal_discount = data.amount_subtotal
            this.totals.iva = data.amount_iva
            this.totals.total = data.amount_total
            this.totals.total_surcharge = data.amount_total_surcharge
          })
        }
      },
      validDiscounts() {
        if(this.crud.form.percentage_discount=='') {
          this.crud.form.percentage_discount = 0
        } else {
          if( parseFloat(this.crud.form.percentage_discount) < 0 ||
              parseFloat(this.crud.form.percentage_discount) > 100 ) {
            this.crud.form.percentage_discount = 0
          }
        }
        this.searchTotalsTemporary()
      },
      detailForceUpdate() {
        this.itemDetailForceUpdate = this.itemDetailForceUpdate + 1
      },

      showSurchargeMethodPayment() {
        this.modal.method_payment.title = "Condiciones de Pago Disponibles"
        this.modal.method_payment.active = true
      },
      setMethodPayment(object) {
        if(object){
          this.crud.form.methods_payment = object
          this.crud.form.methods_payment_id = object.id

          let days = parseInt(object.term)
          this.crud.form.date_expiration = moment(this.crud.form.date).add(days,'d').format('YYYY-MM-DD')
        }

        this.searchTotalsTemporary()
        this.modal.method_payment.active=false
      },
    }
  }
</script>
<style>
  .crud-budgets-wizard .wizard-header {
    padding: 0px;
  }
  .crud-budgets-wizard .wizard-card-footer {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 4px 0;
  }
  .crud-budgets-wizard .wizard-card-footer .wizard-footer-left,
  .crud-budgets-wizard .wizard-card-footer .wizard-footer-right {
    float: none !important;
  }
  .crud-budgets-wizard .wizard-card-footer .wizard-footer-right {
    margin-left: auto;
  }
  .crud-budgets-wizard .wizard-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 112px;
    height: 36px;
    padding: 6px 14px;
    border-width: 1px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: var(--app-font-semibold);
    box-shadow: none;
    transition: background-color .15s ease, border-color .15s ease, color .15s ease;
  }
  .crud-budgets-wizard .wizard-footer-left .wizard-btn::before,
  .crud-budgets-wizard .wizard-footer-right .wizard-btn::after {
    font-family: 'Material Symbols Rounded';
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-feature-settings: 'liga';
    line-height: 1;
  }
  .crud-budgets-wizard .wizard-footer-left .wizard-btn::before {
    content: 'arrow_back';
    margin-right: 6px;
  }
  .crud-budgets-wizard .wizard-footer-right .wizard-btn::after {
    content: 'arrow_forward';
    margin-left: 6px;
  }
  .crud-budgets-wizard .wizard-footer-left .wizard-btn {
    background-color: var(--app-color-surface) !important;
    border-color: var(--app-color-border-strong) !important;
    color: var(--app-color-text-secondary) !important;
  }
  .crud-budgets-wizard .wizard-footer-left .wizard-btn:hover {
    background-color: var(--app-color-surface-subtle) !important;
    color: var(--app-color-text) !important;
  }
  .crud-budgets-wizard .wizard-footer-right .wizard-btn {
    background-color: var(--app-color-primary) !important;
    border-color: var(--app-color-primary) !important;
    color: #fff !important;
  }
  .crud-budgets-wizard .wizard-footer-right .wizard-btn:hover {
    filter: brightness(.94);
  }
  @media (max-width: 767.98px) {
    .crud-budgets-wizard .wizard-card-footer {
      gap: 8px;
      padding: 12px 0 0;
    }
    .crud-budgets-wizard .wizard-footer-left,
    .crud-budgets-wizard .wizard-footer-right {
      display: flex;
      flex: 1 1 0;
    }
    .crud-budgets-wizard .wizard-card-footer .wizard-footer-right {
      margin-left: 0;
    }
    .crud-budgets-wizard .wizard-footer-left > span,
    .crud-budgets-wizard .wizard-footer-right > span {
      display: block;
      width: 100%;
    }
    .crud-budgets-wizard .wizard-btn {
      width: 100%;
      min-width: 0;
    }
  }
  .crud-budgets-stat {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 8px;
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
  }
  .crud-budgets-stat__label {
    color: var(--app-color-text-muted);
    font-size: var(--app-text-xs);
    font-weight: var(--app-font-semibold);
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .crud-budgets-stat__value {
    font-size: 22px;
    font-weight: var(--app-font-semibold);
    color: var(--app-color-text);
  }
  .crud-budgets-totals {
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
    padding: 10px 12px;
  }
  .crud-budgets-totals__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 4px 0;
    font-size: 12px;
  }
  .crud-budgets-totals__row + .crud-budgets-totals__row {
    border-top: 1px dashed var(--app-color-border);
  }
  .crud-budgets-totals__label {
    color: var(--app-color-text-muted);
    font-weight: var(--app-font-semibold);
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.02em;
    flex: 1 1 auto;
    min-width: 0;
  }
  .crud-budgets-totals__value {
    font-weight: var(--app-font-semibold);
    text-align: right;
    white-space: nowrap;
    flex: 0 0 auto;
  }
  .crud-budgets-totals__row--total {
    border-top: 2px solid var(--app-color-primary) !important;
    margin-top: 4px;
    padding-top: 8px;
  }
  .crud-budgets-totals__row--total .crud-budgets-totals__label,
  .crud-budgets-totals__row--total .crud-budgets-totals__value {
    font-size: 14px;
    color: var(--app-color-text);
  }
  .crud-budgets-totals__discount-group {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 0 0 auto;
  }
  .crud-budgets-totals__discount {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .crud-budgets-totals__discount input {
    width: 62px;
    height: 26px;
    padding: 2px 4px;
    text-align: right;
  }
  .crud-budgets-totals__discount-suffix {
    color: var(--app-color-text-muted);
    font-size: 12px;
  }
  .budgets-form-modal-dialog {
    max-width: min(1400px, calc(100vw - 24px));
  }
</style>
